import { BaseService } from 'core/services';
import FacilityOrderPatientRouteService from './FacilityOrderPatientRouteService';

class FacilityOrderPatientService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new FacilityOrderPatientRouteService());
    }

	put(url, resource) {
		const connectionId = sessionStorage.getItem("connectionId");
		return this.apiClient.put(url, resource, connectionId ? { connectionId: connectionId} : null);
    }
	
	create(resource) {
        const url = this.routeService.create(resource);
		const connectionId = sessionStorage.getItem("connectionId");
        return this.apiClient.post(url, resource, connectionId ? { connectionId: connectionId} : null);
    }

    update(resource) {
        const url = this.routeService.update(resource);
        return this.put(url, resource);
    }

    setIsNoteReviewed(resource) {
		const url = this.routeService.setIsNoteReviewed(resource);
		return this.put(url, resource);
	}

    updateNote(resource) {
		const url = this.routeService.updateNote(resource);
		return this.put(url, resource);
	}

	updateInsuranceQuestion(resource) {
		let url = this.routeService.updateInsuranceQuestion(resource);
		if(resource.insuranceQuestion === "" || !resource.insuranceQuestion)
		{
			url+=`"${""}"`;
		}
		return this.put(url, resource);	
	}

	resolveInsuranceQuestion(resource) {
		const url = this.routeService.resolveInsuranceQuestion(resource);
		return this.put(url, resource);
	}

	changeFacilityOrderPatientInsuranceStatus(resource){
		const url = this.routeService.changeFacilityOrderPatientInsuranceStatus(resource);
		return this.put(url, resource);
	}
}

export default FacilityOrderPatientService;
